import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { BrowserIdService } from "../services/browser-id.service";
import { CachingService } from "../services/caching.service";
import { CommonService } from "./common.service";
import { STATIC_KEYS } from "src/constants/constants";

interface requestUrlObj {
  user_id: string;
  device_id: string;
  platform: string;
  session_id: string;
  additional_data?: any;
}

export const attachEncodedDataKeyInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  const browserIdService = inject(BrowserIdService);
  const cachingService = inject(CommonService);

  function base64Encode(obj: requestUrlObj): string {
    const json = JSON.stringify(obj);
    const bytes = new TextEncoder().encode(json);
    const base64 = btoa(String.fromCharCode(...bytes));
    return base64;
  }

  return from(browserIdService.getBrowserId()).pipe(
    switchMap((deviceId) => {
      let userDetails: any = cachingService.getItem(
        STATIC_KEYS.LOGGED_IN_USER_INFO,
        true
      );
      let session_id = cachingService.getItem(STATIC_KEYS.IDP_AUTH_TOKEN);

      const requestData: requestUrlObj = {
        user_id: userDetails?.id,
        device_id: deviceId,
        platform: "cms",
        session_id,
      };

      try {
        const encodedData = base64Encode(requestData);
        const modifiedReq = req.clone({
          setHeaders: {
            data: encodedData,
          },
        });
        return next(modifiedReq);
      } catch (error) {
        return next(req);
      }
    })
  );
};
